import React from 'react';
import { useLabels } from '../contexts/LanguageContext';

const LogoutModal = ({
  isOpen,
  onClose,
  onConfirm,
}: {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
}) => {
  const labels = useLabels();
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black/40 backdrop-blur-sm z-50">
      <div className="bg-white w-[90%] max-w-sm rounded-3xl shadow-2xl p-6 text-center border-t-4 border-brand-700">
        <div className="w-12 h-12 rounded-2xl bg-brand-50 flex items-center justify-center mx-auto mb-3">
          <svg xmlns="http://www.w3.org/2000/svg" className="w-6 h-6 text-brand-700" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
            <path strokeLinecap="round" strokeLinejoin="round" d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a2 2 0 01-2 2H5a2 2 0 01-2-2V7a2 2 0 012-2h6a2 2 0 012 2v1" />
          </svg>
        </div>
        <h2 className="text-xl font-bold text-brand-700 mb-2">{labels.lbl_logout_txt}</h2>
        <p className="text-gray-400 text-sm mb-6">{labels.lbl_logout_confirmation_msg}</p>

        <div className="flex justify-center gap-4">
          <button
            onClick={onClose}
            className="px-8 py-2.5 rounded-full bg-slate-100 text-slate-600 font-semibold hover:bg-slate-200 transition text-sm"
          >
            No
          </button>

          <button
            onClick={onConfirm}
            className="px-8 py-2.5 rounded-full bg-brand-700 text-white font-semibold shadow-md shadow-brand-200 hover:bg-brand-800 transition text-sm"
          >
            Yes
          </button>
        </div>
      </div>
    </div>
  );
};

export default LogoutModal;